import { render, staticRenderFns } from "./benennung.vue?vue&type=template&id=315ef304&"
import script from "./benennung.vue?vue&type=script&lang=js&"
export * from "./benennung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports